import AlarmGroups           from 'scripts/defa/alarm-groups/collection-alarm-groups';
import AlarmGroup            from 'scripts/defa/alarm-groups/model-alarm-group';
import AlarmGroupErrorForm   from 'scripts/defa/alarm-groups/view-alarm-group-error-form';
import AlarmGroupFlow        from 'scripts/defa/alarm-groups/view-alarm-group-flow';
import AlarmGroupOptionForm  from 'scripts/defa/alarm-groups/view-alarm-group-option-form';
import AlarmGroupReplaceFlow from 'scripts/defa/alarm-groups/view-alarm-group-replace-flow';
import Module                from 'scripts/module';

const AlarmGroupsModule = new Module('AlarmGroupsModule', {
	collections: {
		AlarmGroups
	},
	models     : {
		AlarmGroup
	},
	views      : {
		AlarmGroupReplaceFlow,
		AlarmGroupOptionForm,
		AlarmGroupFlow,
		AlarmGroupErrorForm
	}
});
export default AlarmGroupsModule;